module.exports = __webpack_public_path__ + "media/bootstrap-icons/battery-d1474f34.svg";